<template>
  <div>
    <div>
      <v-row class="pt-5 pb-5">
        <v-col cols="10">
          <span class="titulo-header">
            Detalle de campañia Post-Venta Inbound
          </span>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-row style="padding-top: 60px;">
        <v-col :class="
              tabReplace == 1
                ? 'text-center active-color'
                : 'text-center inactive-color'
            " @click="tabReplaceSelect(1)">
          <span :class="
                tabReplace == 1
                  ? 'text-header-step-active'
                  : 'text-header-step-no-active'
              ">
            Detalles</span>
        </v-col>

      </v-row>
    </div>
    <div style="padding-top: 60px;">
      <div v-if="tabReplace == 1">
        <PostVentaDataIndex :cuentaData="cuentaData" />
      </div>
    </div>
  </div>
</template>
  
  <script>

  import PostVentaDataIndex from './PostVentaDataIndex.vue'
  import { getPosVentaDetalles } from "@/services/campañasPostVentaInbound/CampañasPostVentaInbound.js";

  export default {
    components: {
      PostVentaDataIndex
      
    },
    data() {
      return {
        tabReplace: 1,
        cuentaData:{}
      };
    },
    methods: {
        async getCampaniaPosVentaById(){
        this.cuentaData = await getPosVentaDetalles(this.$route.params.id)
        }
    },
    mounted() {
      this.getCampaniaPosVentaById()
    },

  };
  </script>
  
  <style></style>
  